import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * 페이지 경로에 따라 뷰포트 설정을 동적으로 조정하는 컴포넌트
 * 특정 페이지(랜딩, 로그인, 회원가입 등)에서는 반응형 디자인을,
 * 그 외의 페이지에서는 축소된 데스크톱 뷰를 제공합니다.
 */
const ViewportController: React.FC = () => {
    const location = useLocation();

    // 반응형을 유지해야 하는 경로 확인
    const landingPaths = [
        '/',
        '/why',
        '/why/communication',
        '/why/growth',
        '/why/change',
        '/company',
        '/pricing',
    ];
    const isLandingPage = landingPaths.includes(location.pathname);

    const isAuthPage = location.pathname.startsWith('/auth');
    const shouldKeepResponsive = isLandingPage || isAuthPage;

    useEffect(() => {
        const viewportMeta = document.querySelector('meta[name="viewport"]');
        if (viewportMeta) {
            if (shouldKeepResponsive) {
                // 랜딩/로그인/회원가입 페이지는 원래 반응형 설정으로 복원
                viewportMeta.setAttribute(
                    'content',
                    'width=device-width, initial-scale=1.0'
                );
            } else {
                // 나머지 페이지는 축소된 데스크톱 뷰로 설정
                viewportMeta.setAttribute(
                    'content',
                    'width=1024, initial-scale=0.1, maximum-scale=5.0, user-scalable=yes'
                );
            }
        }

        // 컴포넌트가 언마운트될 때 원래 설정으로 복원
        return () => {
            if (viewportMeta) {
                viewportMeta.setAttribute(
                    'content',
                    'width=device-width, initial-scale=1.0'
                );
            }
        };
    }, [shouldKeepResponsive, location.pathname]);

    // 빈 요소 반환 (렌더링은 없음)
    return null;
};

export default ViewportController;
